<template>
  <div class="page-bg login">
    <v-container fill-height justify-center>
      <div class="login-block">
        <div class="Client-logo">
          <img :src="logo" class="Client-logo-img" />
        </div>
        <v-form class="login-frm">
          <v-row>
            <v-col cols="12" sm="12">
              <v-select
                v-model="selectedCenters"
                :items="centers"
                label="Centers"
                hide-details
                item-text="name"
                item-value="id"
                multiple
                dense
                outlined
                class="required"
              ></v-select>
              <InputError :data="error.dataType" />
            </v-col>
            <v-col cols="12" sm="12" class="pad-zero">
              <div class="signup-primary top-0">
                <div class="sign-up-btn">
                  <v-btn
                    @click="onSubmit"
                    class="right-btn cust-btn"
                    color="primary"
                    >Done</v-btn
                  >
                </div>
              </div>
            </v-col>
          </v-row>
        </v-form>
        <div v-if="isDefaultInstitute &&  myInstitute &&!myInstitute.is_white_labeled" class="power-logo">
          <img src="../../../assets/img/logo-footer.png" class="master-logo" />
        </div>
      </div>
    </v-container>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
export default {
  name: "CoordinatorSignupStep2",
  data() {
    return {
      loading: false,
      centers: [],
      selectedCenters: [],
      page: 1,
      teacherEmail: null,
      teacherName: null,
      logo: this.getInstituteLogo(),
      error: {
        dataType: {
          type: null,
          message: "Please select class",
        },
        subjects: {
          type: null,
          message: "Please select subject",
        },
      },
    };
  },
  methods: {
    ...mapActions({
      signUp: "userStore/signUp",
      getCenters: "centerAndBatchStore/getCenters",
    }),
    requestGetCenters() {
      this.$root.showLoader = true;
      this.getCenters()
        .then((response) => {
          this.$root.showLoader = false;
          this.centers = response;
        })
        .catch((err) => {
          this.$root.showLoader = false;
        });
    },
    validate() {
      let isValid = true;
      if (!this.selectedCenters.length) {
        this.$toasted.error(`Please select coordinator centers`);
        isValid = false;
      }
      return isValid;
    },
    onSubmit() {
      if (this.validate()) {
        this.$root.showLoader = true;
        this.signUp({ ...this.signUpData, center_id: this.selectedCenters })
          .then((response) => {
            this.$root.showLoader = false;
            this.$toasted.success(`Success\n${response.message}`, {
              icon: "check_circle", className:'new-class'
            });
            this.$router.push({ name: "login" }).catch(() => {});
          })
          .catch((err) => {
            this.$root.showLoader = false;
          });
      }
    },
  },
  computed: {
    ...mapState("userStore", ["signUpData", "isDefaultInstitute",'myInstitute']),
  },
  mounted() {

    
    this.requestGetCenters();
    // if (!this.signUpData) {
    //     this.$router.push({ name: "signup" });
    // }
  },
};
</script>
